import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_assurance_that_children_are_only_released_parents'

export const dataPointDefinition = {
  retracedId: 'no_assurance_that_children_are_only_released_parents',
  name: 'No assurance that children are only released to parents or other authorized adult/guardians',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-chi-10x',
      number: 'HS-CHI-2-7',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-chi-3',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],fp-bs-8,Yes',
      machineShowHide: '[2],fp-bs-8,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-chi-10x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 30430,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
